import { dashboardApi } from '@/api';
import { queryOptions } from '@tanstack/react-query';

export interface ReportSignedUrlQueryArgs {
    projectId: string;
    dashboardId: string;
    reportId: string;
}

export interface DuckDBSignedUrlResponse {
    signedUrl: string;
}

export const getReportSignedUrl = async ({
    projectId,
    dashboardId,
    reportId,
}: ReportSignedUrlQueryArgs) => {
    return dashboardApi<DuckDBSignedUrlResponse>({
        method: 'GET',
        url: `/front-office/project/${projectId}/dashboard/${dashboardId}/reports/${reportId}`,
        params: {
            timeout: 1000,
        },
    });
};

export const dashboardReportSignedUrlQueryOptions = (
    args: ReportSignedUrlQueryArgs,
) =>
    queryOptions({
        queryKey: ['dashboard-report-signed-url', args],
        queryFn: () => getReportSignedUrl(args),
        staleTime: Infinity,
        enabled: !!args.projectId && !!args.dashboardId && !!args.reportId,
    });
